/* /cdn/shop/t/5/assets/cart-ui--684a57e9.js — the drawer, the nav count, and the binding that makes a button real.
 *
 * Loads AFTER /cdn/shop/t/5/assets/cart--566ede15.js. Nothing here knows how the cart stores anything; it only calls
 * the public surface, so the storage shape can change without touching this file.
 *
 * THE BINDING CONTRACT. A control becomes a working buy control by carrying
 * `data-add="<product-id>"`. That is deliberately explicit rather than clever: the
 * previous failure on this store was buttons that LOOKED complete and did nothing, and a
 * binder that guessed from the button's text would recreate exactly that class of
 * silence when a label changed. If the id is missing or unknown, this logs loudly and
 * marks the button, rather than failing quietly.
 *
 * The drawer is CONFIRMATION only. The decision happens on the cart page, because
 * shoppers use a cart as a holding area and a drawer makes comparing harder.
 */
(function (global) {
  "use strict";

  var C = global.AmkaCart;
  if (!C) { console.error("[amka] /cdn/shop/t/5/assets/cart-ui--684a57e9.js loaded without /cdn/shop/t/5/assets/cart--566ede15.js"); return; }

  var drawer, list, foot, root;

  function el(tag, cls, html) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (html != null) n.innerHTML = html;
    return n;
  }

  function ensure() {
    if (drawer) return;
    root = el("div", "amka-cart-root");
    root.innerHTML =
      '<div class="amka-scrim" data-close></div>' +
      '<aside class="amka-drawer" role="dialog" aria-modal="true" aria-labelledby="amka-drawer-title" aria-hidden="true" tabindex="-1">' +
        '<header><b id="amka-drawer-title">Your bag</b>' +
          '<button class="amka-x" data-close aria-label="Close">Close</button></header>' +
        '<div class="amka-shipping" role="status" aria-live="polite"><p></p><div class="amka-shipping-track"><span></span></div></div>' +
        '<div class="amka-list"></div>' +
        '<footer class="amka-foot"></footer>' +
      '</aside>';
    document.body.appendChild(root);
    drawer = root.querySelector(".amka-drawer");
    setInert(true);                    /* it starts closed */
    list = root.querySelector(".amka-list");
    foot = root.querySelector(".amka-foot");
    root.addEventListener("click", function (e) {
      if (e.target.hasAttribute && e.target.hasAttribute("data-close")) close();
    });
    document.addEventListener("keydown", function (e) {
      if (!root || !root.classList.contains("open")) return;
      if (e.key === "Escape") { e.preventDefault(); close(); return; }
      if (e.key !== "Tab") return;
      /* keep Tab inside the dialog: without this the focus walks the page behind it */
      var f = focusables();
      if (!f.length) { e.preventDefault(); return; }
      var first = f[0], last = f[f.length - 1], a = document.activeElement;
      if (e.shiftKey && (a === first || !drawer.contains(a))) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && (a === last || !drawer.contains(a))) { e.preventDefault(); first.focus(); }
    });
  }

  /* a closed drawer keeps its buttons in the tab order unless it is inert (or hidden) */
  function setInert(on) {
    if (!drawer) return;
    if ("inert" in HTMLElement.prototype) drawer.inert = on;
    else drawer.style.visibility = on ? "hidden" : "";
  }

  /* every control the keyboard can reach inside the drawer, in DOM order */
  function focusables() {
    if (!drawer) return [];
    return [].slice.call(drawer.querySelectorAll(
      'a[href], button:not([disabled]), input:not([disabled]), select, textarea, [tabindex]:not([tabindex="-1"])'
    )).filter(function (n) { return n.offsetParent !== null; });
  }

  var lastFocus = null, lastOverflow = "", openFrame = 0;

  function open() {
    ensure();
    if(root.classList.contains("open") || openFrame)return;
    render();
    lastFocus = document.activeElement;                 /* so Escape returns the keyboard where it was */
    // Give newly created drawers a painted closed frame before starting the slide.
    // Focus must not scroll the off-screen panel into view.
    void drawer.offsetWidth;
    openFrame = requestAnimationFrame(function(){
      openFrame = requestAnimationFrame(function(){
        openFrame = 0;
        root.classList.add("open");
        var f = focusables();
        (f[0] || drawer).focus({preventScroll:true});
      });
    });
    drawer.setAttribute("aria-hidden", "false");
    setInert(false);
    lastOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";            /* the page behind must not scroll */

  }

  function close() {
    if (!root) return;
    cancelAnimationFrame(openFrame);openFrame=0;
    root.classList.remove("open");
    drawer.setAttribute("aria-hidden", "true");
    setInert(true);                    /* transform + pointer-events do NOT remove controls from tab order */
    document.body.style.overflow = lastOverflow;
    if (lastFocus && document.contains(lastFocus)) lastFocus.focus();
    lastFocus = null;
  }

  /* /cdn/shop/t/5/assets/cart--566ede15.js already captured the store root at ITS load time, which is the only moment
     document.currentScript is trustworthy. Reuse it rather than repeating the trick and
     getting it wrong in a second place. */
  function cartHref() { return "/cart"; }

  function render() {
    if (!list) return;
    var its = C.items();
    var shipping = root.querySelector('.amka-shipping');
    var remaining = Math.max(0, 8000 - C.subtotal());
    shipping.hidden = !its.length;
    shipping.querySelector('p').textContent = remaining ? 'Just ' + C.format(remaining) + ' to free shipping.' : 'Free shipping is yours.';
    shipping.querySelector('span').style.transform = 'scaleX(' + Math.min(1, C.subtotal()/8000) + ')';
    if (!its.length) {
      list.innerHTML = '<p class="amka-empty">Your bag is empty.</p>';
      foot.innerHTML = "";
      return;
    }
    list.innerHTML = its.map(function (it) {
      return '<div class="amka-line">' +
        (it.image ? '<img src="' + it.image + '" alt="">' : '<span class="amka-noimg"></span>') +
        '<div class="amka-meta"><b>' + esc(it.name) + '</b>' +
          '<span>' + (it.line != null ? C.format(it.line)
                     : esc(it.priceNote || "price on request")) + '</span></div>' +
        '<div class="amka-qty">' +
          '<button data-dec="' + esc(it.key) + '" aria-label="One fewer">&minus;</button>' +
          '<span>' + it.qty + '</span>' +
          '<button data-inc="' + esc(it.key) + '" aria-label="One more">+</button>' +
        '</div></div>';
    }).join("");

    var un = C.unpriced().length;
    foot.innerHTML =
      '<div class="amka-sub"><span>Subtotal</span><b data-cart-total>' + C.format(C.subtotal()) + '</b></div>' +
      (un ? '<p class="amka-note">' + un + ' item' + (un === 1 ? " is" : "s are") +
            ' priced in store and are not in this total.</p>' : "") +
      '<p class="amka-tbc"><b>Taxes and shipping are calculated at checkout.</b> </p>' +
      '<p class="amka-tbc">Free shipping from KSh 8,000. Below that: Nairobi KSh 250 · Upcountry KSh 500. Pickup available.</p>' +
      (C.checkoutUrl
        ? (C.checkoutUrl()
            ? '<a class="amka-go amka-checkout" data-checkout href="' + C.checkoutUrl() +
              '" rel="noopener">Checkout</a>'
            : '<p class="amka-note">Checkout needs a live variant for every line. Pick a size on the product page.</p>')
        : "") +
      '<a class="amka-go secondary" href="' + cartHref() + '">Go to your bag</a>';
  }

  function esc(s) {
    return String(s == null ? "" : s).replace(/[&<>"]/g, function (c) {
      return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[c];
    });
  }

  /* quantity controls inside the drawer. render() replaces the list, so the button the
     keyboard was on stops existing: put focus back on the SAME control, or on Close when
     the line is gone. (Codex live keyboard test, 2026-09-09) */
  function restoreFocus(attr, key) {
    var again = drawer && drawer.querySelector('[' + attr + '="' + (window.CSS && CSS.escape ? CSS.escape(key) : key) + '"]');
    if (again && again.offsetParent !== null) { again.focus(); return; }
    var f = focusables();
    if (f.length) f[0].focus();                 /* the line went away: Close is the first control */
  }

  document.addEventListener("click", function (e) {
    var t = e.target;
    if (!t || !t.getAttribute) return;
    var inc = t.getAttribute("data-inc"), dec = t.getAttribute("data-dec");
    var byKeyboard = drawer && drawer.contains(t);
    if (inc) { C.add(inc, 1); render(); if (byKeyboard) restoreFocus("data-inc", inc); }
    if (dec) {
      var cur = C.items().filter(function (i) { return i.key === dec; })[0];
      C.setQuantity(dec, (cur ? cur.qty : 1) - 1);
      render();
      if (byKeyboard) restoreFocus("data-dec", dec);
    }
  });

  /* CATALOGUE READINESS, shared by every control on the page.

     Root reproduced this on a throttled connection: products.json delayed 5s, the page
     interactive at 1.21s, the Add button rendered ENABLED, a real click at 1.3s, and six
     seconds later the bag still read 0 with no drawer. The click was not slow, it was
     LOST: binding happened inside C.load().then, so until the fetch returned there was no
     handler to receive it.

     So the handlers are attached immediately and the readiness is handled where it
     belongs, inside the click: an early click is queued with visible feedback and runs
     the moment the catalogue lands. Intent is never dropped in silence. */
  /* ONE readiness object, re-entrant. The first version kept a promise in a variable and
     a catFailed flag beside it, which could not recover: /cdn/shop/t/5/assets/cart--566ede15.js cached {} on a 503 so the
     rejection branch never ran, and even if it had, the cached promise could not be
     retried. Root reproduced exactly that, one 503 and the page stayed dead.

     ensure() now creates a FRESH load on every attempt after a failure, and everything
     that waits on the catalogue waits on ensure(). Every call site attaches a rejection
     handler, so a failure is reported, never unhandled. */
  var catReady = false, catFailed = false, pending = null;

  function ensureCatalogue() {
    if (catReady) return Promise.resolve();
    if (pending) return pending;
    pending = (C.load ? C.load() : Promise.resolve()).then(function (v) {
      catReady = true; catFailed = false; pending = null;
      clearLoading(); clearRetry();
      return v;
    }, function (err) {
      catFailed = true; pending = null;     // NOT cached: the next ensure() really refetches
      clearLoading(); showRetry();
      throw err;
    });
    return pending;
  }

  /* THE RETRY CONTROL. A failed catalogue has to say so on the control the customer is
     looking at, not only in the console, and pressing it has to cause a real second fetch. */
  function showRetry() {
    document.querySelectorAll("[data-add]").forEach(function (b) {
      if (b.hasAttribute("disabled")) return;
      b.setAttribute("data-retry", "1");
      var el = b.querySelector(".cl") || b;
      if (b.__amkaLabel == null) b.__amkaLabel = el.textContent;
      el.textContent = "Try again";
      b.setAttribute("aria-busy", "false");
    });
  }
  function clearRetry() {
    document.querySelectorAll("[data-add][data-retry]").forEach(function (b) {
      b.removeAttribute("data-retry");
      var el = b.querySelector(".cl") || b;
      if (b.__amkaLabel != null) { el.textContent = b.__amkaLabel; b.__amkaLabel = null; }
    });
  }

  /* Marked the moment the script runs, cleared when the catalogue resolves. The customer
     sees a control that is honestly not ready yet, instead of one that looks ready and
     swallows the tap. Root asked for this branch first and the queue second; both are in. */
  function markLoading(scope) {
    (scope || document).querySelectorAll("[data-add]").forEach(function (b) {
      if (b.hasAttribute("disabled")) return;          // already sold out, leave it alone
      b.setAttribute("data-loading", "1");
      b.setAttribute("aria-busy", "true");
      var el = b.querySelector(".cl") || b;
      if (b.__amkaReady === undefined) b.__amkaReady = el.textContent;
    });
  }
  function clearLoading() {
    document.querySelectorAll("[data-add][data-loading]").forEach(function (b) {
      b.removeAttribute("data-loading");
      b.setAttribute("aria-busy", "false");
    });
  }

  function busy(b, on, label) {
    b.setAttribute("aria-busy", on ? "true" : "false");
    if (on) b.setAttribute("data-pending", "1"); else b.removeAttribute("data-pending");
    var el = b.querySelector(".cl") || b;
    if (on && !b.__amkaLabel) b.__amkaLabel = el.textContent;
    if (!on && b.__amkaLabel) { el.textContent = b.__amkaLabel; b.__amkaLabel = null; }
    else if (on) el.textContent = label || "Adding...";
  }

  /* THE BINDER. Explicit ids only, and it complains out loud when one is wrong. */
  function bind(scope) {
    (scope || document).querySelectorAll("[data-add]").forEach(function (b) {
      if (b.__amkaBound) return;
      b.__amkaBound = true;
      /* Sold out on the live store: the control says so and does nothing, wherever it
         sits (search, cross-sells, shelves). Astra review 2026-09-08, finding 2. */
      var gate = function () {
        if (C.purchasable && !C.purchasable(b.getAttribute("data-add"))) {
          b.setAttribute("disabled", ""); b.setAttribute("aria-disabled", "true");
          if (b.tagName === "BUTTON") { var lbl = b.querySelector(".cl"); if (lbl) lbl.textContent = "Sold out"; else b.textContent = "Sold out"; }
        }
      };
      /* the snapshot may still be loading on pages that render controls early (search).
         gate() runs only on SUCCESS: a failed fetch must never paint the shelf sold out. */
      ensureCatalogue().then(gate, function () {});

      /* THE INTENT IS A SNAPSHOT, taken the instant the customer presses.

         Root's repro: press Add on 500g while products.json is still in flight, change the
         size selector to 250g before it lands, and checkout came back 51135178572058:1.
         The 500g press bought 250g. The reason is that doAdd used to read the BUTTON when
         it finally ran, and the page's option controls rewrite data-variant-id on that
         same button, so by then the button no longer described what was pressed.

         What was pressed is now captured here and nothing else is consulted later. */
      function snapshot(b) {
        var vid = b.getAttribute("data-variant-id");
        return {
          id: b.getAttribute("data-add"),
          variantId: vid || null,
          variantTitle: b.getAttribute("data-variant-title") || "",
          variantPrice: parseFloat(b.getAttribute("data-variant-price")),
          grind: b.getAttribute("data-grind") || null,
          qty: parseInt(b.getAttribute("data-qty") || "1", 10) || 1
        };
      }

      function doAdd(b, intent) {
        var i = intent || snapshot(b);
        if (C.needsGrind && C.needsGrind(i.id) && !i.grind && global.AmkaGrind) {
          global.AmkaGrind.need(i, b, function (code) { i.grind = code; doAdd(b, i); });
          return;
        }
        if (!C.product(i.id)) {
          console.error("[amka] no product with id", i.id, "on", b);
          b.setAttribute("data-add-broken", "1");
          return;
        }
        /* A control may name the chosen Shopify variant, captured at press time above.
           Without one the product-level add works as it always did and checkout falls back
           to the first purchasable variant. */
        var v = i.variantId
          ? { id: i.variantId, title: i.variantTitle, price: i.variantPrice }
          : (C.firstVariant ? C.firstVariant(i.id) : null);
        /* every line is product@variant: a Quick Add resolves to the first purchasable variant */
        var key = C.lineKey ? C.lineKey(i.id, v && v.id, i.grind) : (v && v.id ? i.id + "@" + v.id : i.id);
        if (v && v.id) C.setVariant(key, v);
        C.add(key, i.qty);
        confirmAdded(b);
      }

      b.addEventListener("click", function (e) {
        if (b.hasAttribute("disabled")) { e.preventDefault(); return; }
        e.preventDefault();
        var intent = snapshot(b);          // what was pressed, before anything can move
        if (catReady) { doAdd(b, intent); return; }
        /* EXACTLY ONCE. A second tap while one intent is already waiting must not queue a
           second add: the customer pressed twice because nothing happened, not because
           they wanted two bags. */
        if (b.__amkaWaiting) return;
        b.__amkaWaiting = true;
        clearRetry();
        busy(b, true);
        ensureCatalogue().then(function () {
          b.__amkaWaiting = false; busy(b, false); doAdd(b, intent);
        }, function () {
          b.__amkaWaiting = false; busy(b, false); showRetry();
        });
      });
    });
  }

  /* THE AUDIT. Any buy-shaped control with no data-add is reported in the console, so a
     forgotten wiring shows up the moment the page loads instead of the moment a customer
     taps it. This is the check that would have caught all 26 dead buttons. */
  function audit() {
    var missed = [];
    document.querySelectorAll("button, [role=button]").forEach(function (b) {
      var t = (b.innerText || "").trim();
      if (!/\b(add|buy|shop now|order|checkout)\b/i.test(t)) return;
      if (b.hasAttribute("data-add") || b.hasAttribute("data-set")) return;   /* set buttons are wired by their page */
      if (b.closest("a[href]:not([href^='#'])")) return;
      if (b.closest(".amka-cart-root")) return;
      missed.push(t);
    });
    if (missed.length) {
      console.error("[amka] " + missed.length +
        " buy-shaped control(s) with no data-add, so they do NOTHING:", missed);
    }
    return missed;
  }

  function mountCount(node) {
    if (!node) return;
    C.subscribe(function (s) {
      node.textContent = s.count;
      node.setAttribute("data-count", s.count);
      var a = node.closest("a, button");
      if (a) a.setAttribute("aria-label", "Cart, " + s.count + " item" + (s.count === 1 ? "" : "s"));
    });
  }

  var addedNotice,noticeTimer;
  function showAddedNotice(){
    if(!addedNotice){addedNotice=el('div','amka-added-notice');addedNotice.style.cssText='position:fixed;top:90px;right:16px;z-index:9900;display:flex;align-items:center;gap:16px;padding:12px 18px;border-radius:999px;background:#fffdf7;border:1px solid #ddd8cd;box-shadow:0 4px 18px #0001;font:inherit';addedNotice.innerHTML='<span role="status">Added to your bag</span><button type="button" style="font:inherit;border:0;background:none;text-decoration:underline;cursor:pointer">View bag</button>';addedNotice.querySelector('button').onclick=function(){addedNotice.hidden=true;addedNotice.style.display='none';open();};document.body.append(addedNotice);}
    addedNotice.hidden=false;addedNotice.style.display='flex';clearTimeout(noticeTimer);noticeTimer=setTimeout(function(){if(!addedNotice.contains(document.activeElement)){addedNotice.hidden=true;addedNotice.style.display='none';}},6000);
  }
  function confirmAdded(button) {
    showAddedNotice();
    var previous = button.querySelector('.amka-added-feedback');
    if (previous) previous.remove();
    var label = document.createElement('span');
    label.className = 'amka-added-feedback';
    label.textContent = 'Added ✓';
    label.setAttribute('role', 'status');
    label.style.cssText = 'position:absolute;inset:0;display:flex;align-items:center;justify-content:center;border-radius:inherit;background:#244b37;color:white;pointer-events:none;font:inherit;z-index:2';
    if (getComputedStyle(button).position === 'static') button.style.position = 'relative';
    button.appendChild(label);
    if (!matchMedia('(prefers-reduced-motion: reduce)').matches) {
      label.animate([{opacity:0},{opacity:1}],{duration:150,fill:'both'});
      document.querySelectorAll('[data-cart-count]').forEach(function(count){count.animate([{transform:'scale(1)'},{transform:'scale(1.2)'},{transform:'scale(1)'}],{duration:350,easing:'ease-out'});});
    }
    setTimeout(function(){ label.remove(); }, 1400);
  }

  global.AmkaCartUI = {
    bind: bind, open: open, close: close, render: render, confirmAdded: confirmAdded, showAddedNotice: showAddedNotice,
    audit: audit, mountCount: mountCount, cartHref: cartHref
  };

  /* Bind NOW, not after the fetch. Every control exists from the first paint, and the
     readiness is handled inside each handler. */
  markLoading(document);
  bind(document);
  document.querySelectorAll("[data-cart-count]").forEach(mountCount);
  document.querySelectorAll("[data-cart-open]").forEach(function (b) {
    b.addEventListener("click", function (e) { e.preventDefault(); open(); });
  });
  audit();
  ensureCatalogue().then(function () { bind(document); clearLoading(); },
                        function () {});
})(window);

/* >>> AMKA-BLOCK blocks/live.js */
/* AMKA LIVE LAYER (2026-09-24). Appended to /cdn/shop/t/5/assets/cart-ui--684a57e9.js so it runs on every page with a bag.

   1. PRICES FROM THE STORE. Every price on the page is repainted from live data: on Shopify the
      theme renders window.AMKA_LIVE from all_products on every request, elsewhere it falls back
      to /cdn/shop/t/5/assets/variants--e99c4f20.json. A price change in Shopify admin shows with no re-push. Each decision
      is logged in AmkaLive.log (what text, which product, how it was matched) for audit.
   2. COFFEE PAGES. Size pickers go (250g only). The type choice is rebuilt from the live
      variants. Kenya AA, Terroir and Experimental get Koi's grind picker, a required choice with
      no preselection; the Blend says "Pre-ground · Medium grind".
   3. GRIND SHEET. A quick-add of a grind coffee from anywhere else (home hero, cards, sets,
      search) opens a small sheet in the bag drawer's visual language and asks for the grind.
   4. CHECKOUT. The Checkout link first makes the store cart match the bag (grind included),
      then opens /checkout. */
(function (global) {
  "use strict";
  var C = global.AmkaCart, D = global.document;
  if (!C || global.AmkaLive) return;
  var COFFEES = ["kenya-aa", "blend", "terroir", "experimental"];
  var LIVE = null, LOG = [], BUSY = false;
  var API = global.AmkaLive = { log: LOG, paint: function () { paint(); }, ready: null };

  function fmt(n) { return "KSh " + Math.round(n).toLocaleString("en-KE"); }
  function tidy(t) { return String(t || "").replace(/\s*—\s*/g, " · "); }
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[c]; }); }
  function pageId() { return (D.body && D.body.dataset.product) || null; }
  function variants(id) {
    var p = LIVE && LIVE[id]; if (!p || !p.variants) return [];
    var a = p.variants.filter(function (v) { return v.available; });
    return a.length ? a : p.variants;
  }
  function range(list) {
    var ps = list.map(function (v) { return parseFloat(v.price); }).filter(isFinite);
    return ps.length ? { lo: Math.min.apply(null, ps), hi: Math.max.apply(null, ps) } : null;
  }
  function variantById(id, vid) {
    var p = LIVE && LIVE[id]; if (!p) return null;
    for (var i = 0; i < p.variants.length; i++) if (String(p.variants[i].id) === String(vid)) return p.variants[i];
    return null;
  }
  function idFromHref(href) {
    if (!href || /^(#|mailto:|tel:|javascript:)/.test(href)) return null;
    var u; try { u = new URL(href, global.location.href); } catch (e) { return null; }
    var m = u.pathname.match(/\/products\/([^\/?#]+)/);
    if (m) { for (var k in LIVE) if (LIVE[k].handle === decodeURIComponent(m[1])) return k; return null; }
    m = u.pathname.match(/\/(?:pdp|product)\/([\w-]+)\/?$/);
    return m && LIVE[m[1]] ? m[1] : null;
  }

  /* ---- styles (grind picker on the product page, and the sheet) ------------------------ */
  var css = D.createElement("style");
  css.textContent =
    ".tabs.grind .tab{align-items:flex-start}.tabs.grind .tab .box{margin-top:3px}" +
    ".tabs.grind .tab{justify-content:flex-start}.tabs.grind .gtxt{display:flex;flex-direction:column;align-items:flex-start;gap:3px;text-align:left}.tabs.grind .gtxt small{font-size:13px;line-height:1.35;opacity:.72;font-weight:500}" +
    ".tabs.grind.need .tab{border-color:#B3261E}.grind-err{color:#B3261E;font-weight:700;font-size:14px;margin:10px 0 0}" +
    ".amka-grindnote{margin:22px 0 0;font-weight:800;font-size:15px}" +
    ".amka-g-root{position:fixed;inset:0;z-index:1000;display:flex;align-items:flex-end;justify-content:center;font-family:Averta,-apple-system,BlinkMacSystemFont,'Segoe UI',Helvetica,Arial,sans-serif;color:#14110E}" +
    ".amka-g-scrim{position:absolute;inset:0;background:rgba(20,17,14,.3);opacity:0;transition:opacity 300ms cubic-bezier(.22,1,.36,1)}" +
    ".amka-g-sheet{position:relative;width:min(520px,100vw);max-height:92vh;overflow:auto;background:#FFFDF7;border-radius:24px 24px 0 0;padding:22px 20px 24px;transform:translateY(100%);transition:transform 320ms cubic-bezier(.22,1,.36,1);box-shadow:0 -8px 30px rgba(20,17,14,.14)}" +
    ".amka-g-root.open .amka-g-scrim{opacity:1}.amka-g-root.open .amka-g-sheet{transform:none}" +
    "@media (min-width:700px){.amka-g-root{align-items:center}.amka-g-sheet{border-radius:24px;transform:translateY(24px);opacity:0;transition:transform 320ms cubic-bezier(.22,1,.36,1),opacity 200ms ease}.amka-g-root.open .amka-g-sheet{opacity:1}}" +
    "@media (prefers-reduced-motion:reduce){.amka-g-scrim,.amka-g-sheet{transition:none}}" +
    ".amka-g-kicker{margin:0 44px 4px 0;font-size:13px;font-weight:700;opacity:.62}.amka-g-sheet h2{margin:0 44px 16px 0;font-size:20px;font-weight:800;line-height:1.2}" +
    ".amka-g-x{position:absolute;top:14px;right:14px;width:44px;height:44px;border:0;border-radius:999px;background:transparent;font-size:26px;line-height:1;cursor:pointer;color:inherit}" +
    ".amka-g-sheet .tabs{display:grid;gap:10px}.amka-g-sheet .tab{position:relative;display:flex;align-items:flex-start;gap:12px;border:1.5px solid #E6E0D4;border-radius:18px;padding:13px 15px;min-height:52px;background:#fff;cursor:pointer;text-align:left;width:100%;font:inherit;color:inherit;justify-content:flex-start}" +
    ".amka-g-sheet .tab .box{flex:0 0 16px;height:16px;margin-top:3px;border:1.5px solid #14110E;border-radius:50%}.amka-g-sheet .tab.on{border-color:#14110E;background:#F7F3EA}.amka-g-sheet .tab.on .box{background:#14110E;box-shadow:inset 0 0 0 3px #fff}" +
    ".amka-g-sheet .gtxt{display:flex;flex-direction:column;align-items:flex-start;gap:3px;text-align:left}.amka-g-sheet .gtxt b{font-weight:800}.amka-g-sheet .gtxt small{font-size:13px;line-height:1.35;opacity:.72}" +
    ".amka-g-go{display:flex;justify-content:center;align-items:center;width:100%;min-height:52px;margin-top:22px;border:0;border-radius:999px;background:#111010;color:#fff;font:inherit;font-weight:800;font-size:16px;cursor:pointer}.amka-g-go[aria-disabled=true]{opacity:.5}";
  D.head.appendChild(css);

  function grindOptions() {
    return C.GRINDS.map(function (g) {
      return '<button type="button" class="tab" role="radio" aria-checked="false" data-grind="' + g.code + '">' +
        '<span class="box"></span><span class="gtxt"><b>' + esc(g.head) + '</b><small>' + esc(g.detail) + '</small></span></button>';
    }).join("");
  }
  function pick(group, code) {
    [].forEach.call(group.querySelectorAll("[data-grind]"), function (b) {
      var on = b.getAttribute("data-grind") === code;
      b.classList.toggle("on", on); b.setAttribute("aria-checked", String(on)); b.tabIndex = on || (!code && b === group.querySelector("[data-grind]")) ? 0 : -1;
    });
  }
  function radioKeys(group, onPick) {       /* arrow keys move the choice, like native radios */
    group.addEventListener("keydown", function (e) {
      if (!/^Arrow(Up|Down|Left|Right)$/.test(e.key)) return;
      var bs = [].slice.call(group.querySelectorAll("[data-grind]")), i = bs.indexOf(D.activeElement);
      if (i < 0) return; e.preventDefault();
      var j = (i + (/Up|Left/.test(e.key) ? -1 : 1) + bs.length) % bs.length;
      bs[j].focus(); onPick(bs[j].getAttribute("data-grind"));
    });
  }

  /* ---- the grind sheet -------------------------------------------------------------- */
  function ask(opts) {
    return new Promise(function (resolve) {
      var id = opts.id, p = C.product && C.product(id), name = (p && p.name) || id, r = range(variants(id));
      var back = D.activeElement, code = null;
      var root = D.createElement("div");
      root.className = "amka-g-root";
      root.innerHTML = '<div class="amka-g-scrim"></div><div class="amka-g-sheet" role="dialog" aria-modal="true" aria-labelledby="amka-g-title">' +
        '<button type="button" class="amka-g-x" aria-label="Close">&times;</button>' +
        '<p class="amka-g-kicker">' + esc(opts.set ? opts.set + " · " + name : name) + '</p>' +
        '<h2 id="amka-g-title">Customize your coffee grind</h2>' +
        '<div class="tabs grind" role="radiogroup" aria-labelledby="amka-g-title">' + grindOptions() + '</div>' +
        '<p class="grind-err" hidden role="alert">Choose your grind to continue.</p>' +
        '<button type="button" class="amka-g-go" aria-disabled="true">' +
        esc(opts.button || ("Add to bag" + (r ? " · " + fmt(r.lo) : ""))) + '</button></div>';
      D.body.appendChild(root);
      var group = root.querySelector(".tabs"), go = root.querySelector(".amka-g-go"), err = root.querySelector(".grind-err");
      function choose(c) { code = c; pick(group, c); go.setAttribute("aria-disabled", "false"); err.hidden = true; }
      pick(group, null); radioKeys(group, choose);
      group.addEventListener("click", function (e) { var b = e.target.closest("[data-grind]"); if (b) choose(b.getAttribute("data-grind")); });
      function close(result) {
        D.removeEventListener("keydown", onKey, true);
        root.classList.remove("open");
        setTimeout(function () { root.remove(); }, 340);
        if (back && back.focus) back.focus({ preventScroll: true });
        resolve(result);
      }
      function onKey(e) {
        if (e.key === "Escape") { e.preventDefault(); close(null); }
        if (e.key === "Tab") {                      /* keep focus inside the sheet */
          var f = [].slice.call(root.querySelectorAll("button")).filter(function (b) { return b.tabIndex !== -1; });
          var i = f.indexOf(D.activeElement);
          if (e.shiftKey && i <= 0) { e.preventDefault(); f[f.length - 1].focus(); }
          else if (!e.shiftKey && i === f.length - 1) { e.preventDefault(); f[0].focus(); }
        }
      }
      D.addEventListener("keydown", onKey, true);
      root.querySelector(".amka-g-scrim").addEventListener("click", function () { close(null); });
      root.querySelector(".amka-g-x").addEventListener("click", function () { close(null); });
      go.addEventListener("click", function () { if (!code) { err.hidden = false; return; } close(code); });
      requestAnimationFrame(function () { root.classList.add("open"); group.querySelector("[data-grind]").focus({ preventScroll: true }); });
    });
  }
  function need(intent, button, cb) {
    var picker = D.querySelector('.tabs.grind[data-grind-for="' + intent.id + '"]');
    if (picker) {                                   /* the choice is right here on the product page */
      picker.classList.add("need");
      var e = picker.parentNode.querySelector(".grind-err"); if (e) e.hidden = false;
      picker.scrollIntoView({ block: "center", behavior: global.matchMedia("(prefers-reduced-motion: reduce)").matches ? "auto" : "smooth" });
      var first = picker.querySelector("[data-grind]"); if (first) first.focus({ preventScroll: true });
      return;
    }
    ask({ id: intent.id }).then(function (code) { if (code) cb(code); });
  }
  global.AmkaGrind = { ask: ask, need: need };

  /* ---- coffee product pages ---------------------------------------------------------- */
  function buildCoffee(id) {
    var buy = D.getElementById("buy"), P = LIVE && LIVE[id];
    if (!buy || !P || buy.querySelector(".amka-options")) return;
    var anchor = null;
    [].slice.call(buy.querySelectorAll(".tabs, .pills")).forEach(function (g) {
      var lbl = g.previousElementSibling, isLbl = lbl && lbl.classList.contains("lbl");
      if (!anchor) { anchor = D.createElement("div"); (isLbl ? lbl : g).before(anchor); }
      if (isLbl) lbl.remove();
      g.remove();
    });
    var add = D.getElementById("addbtn");
    if (!anchor) { anchor = D.createElement("div"); if (add) add.before(anchor); else return; }
    anchor.className = "amka-options";
    var choice = [];
    (P.options || []).forEach(function (name, i) {
      if (/^(quantity|size|grind)$/i.test(name)) return;
      var vals = [];
      P.variants.forEach(function (v) { var x = v.options && v.options[i]; if (x && vals.indexOf(x) < 0) vals.push(x); });
      if (vals.length > 1) choice.push({ i: i, name: name, vals: vals });
    });
    var html = choice.map(function (c) {
      return '<span class="lbl">Choose your ' + esc(c.name.toLowerCase()) + ':</span><div class="pills" role="radiogroup" aria-label="' + esc(c.name) + '">' +
        c.vals.map(function (v) {
          return '<button type="button" class="pill" role="radio" aria-checked="false" data-opt="' + c.i + '" data-val="' + esc(v) + '">' + esc(tidy(v).replace(/^AMKA EXPERIMENTAL · /, "")) + '</button>';
        }).join("") + '</div>';
    }).join("");
    if (C.needsGrind(id)) {
      html += '<span class="lbl" id="grind-lbl">Customize your coffee grind</span>' +
        '<div class="tabs grind" role="radiogroup" aria-labelledby="grind-lbl" aria-required="true" data-grind-for="' + id + '">' + grindOptions() + '</div>' +
        '<p class="grind-err" hidden role="alert">Choose your grind to add this coffee.</p>';
    } else if (id === "blend") {
      html += '<p class="amka-grindnote">Pre-ground · Medium grind</p>';
    }
    anchor.innerHTML = html;
    var sel = {}, grind = null;
    var first = variants(id)[0];
    choice.forEach(function (c) { if (first) sel[c.i] = first.options[c.i]; });
    var buttons = [].slice.call(D.querySelectorAll('#buy [data-add="' + id + '"], .stickybar [data-add="' + id + '"]'));
    function current() {
      var m = P.variants.filter(function (v) { return choice.every(function (c) { return v.options[c.i] === sel[c.i]; }); });
      return m.filter(function (v) { return v.available; })[0] || m[0] || null;
    }
    function update() {
      [].forEach.call(anchor.querySelectorAll(".pill"), function (b) {
        var on = sel[b.dataset.opt] === b.dataset.val;
        b.classList.toggle("on", on); b.setAttribute("aria-checked", String(on));
        b.disabled = !P.variants.some(function (v) { return v.available && v.options[b.dataset.opt] === b.dataset.val; });
      });
      var v = current();
      buttons.forEach(function (a) {
        var pr = a.querySelector("[data-price]"), cl = a.querySelector(".cl");
        if (v) {
          a.setAttribute("data-variant-id", v.id); a.setAttribute("data-variant-title", tidy(v.title)); a.setAttribute("data-variant-price", v.price);
          if (pr) pr.textContent = fmt(parseFloat(v.price));
        }
        if (grind) a.setAttribute("data-grind", grind); else a.removeAttribute("data-grind");
        a.disabled = !v || !v.available; a.removeAttribute("aria-disabled");
        if (cl) cl.textContent = v && !v.available ? "Sold out" : "Add to bag";
      });
    }
    anchor.addEventListener("click", function (e) {
      var p = e.target.closest(".pill");
      if (p && !p.disabled) { sel[p.dataset.opt] = p.dataset.val; update(); return; }
      var g = e.target.closest("[data-grind]");
      if (g) { grind = g.getAttribute("data-grind"); setGrind(); }
    });
    function setGrind() {
      var group = anchor.querySelector(".tabs.grind");
      pick(group, grind); group.classList.remove("need");
      var er = anchor.querySelector(".grind-err"); if (er) er.hidden = true;
      update();
    }
    var gg = anchor.querySelector(".tabs.grind");
    if (gg) { pick(gg, null); radioKeys(gg, function (c) { grind = c; setGrind(); }); }
    update();
  }

  /* ---- price painter ----------------------------------------------------------------- */
  var SKIP = "script,style,noscript,textarea,.amka-cart-root,.cartpage,[data-live-skip],.amka-g-root";
  var SHIPPING = /deliver|upcountry|pick ?up|shipping|postage/i;
  var ONLY = /^(from\s+)?KSh\s?[\d,]+$/i, LABEL = /^(add\b.*?\s·\s)(from\s+)?KSh\s?[\d,]+$/i, LEAD = /^(from\s+)?KSh\s?[\d,]+(\s*·.*)$/i;
  function priceText(r, orig, exact) {
    var from = /^from/i.test(orig) ? orig.slice(0, 4) : "from";
    if (exact || r.hi <= r.lo) return fmt(r.lo);
    return from + " " + fmt(r.lo);
  }
  function setSum(tokens) {
    var sum = 0;
    for (var i = 0; i < tokens.length; i++) {
      var id = tokens[i].split("@")[0], vid = (tokens[i].split("@")[1] || "").split("|")[0];
      var v = vid ? variantById(id, vid) : null, r = v ? { lo: parseFloat(v.price) } : range(variants(id));
      if (!r) return null;
      sum += r.lo;
    }
    return { lo: sum, hi: sum };
  }
  function context(el) {
    var btn = el.closest("[data-variant-id]");
    if (btn && btn.hasAttribute("data-add")) { var id0 = btn.getAttribute("data-add"), v0 = variantById(id0, btn.getAttribute("data-variant-id")); if (v0) return { r: { lo: parseFloat(v0.price), hi: parseFloat(v0.price) }, how: "variant " + v0.id, exact: true }; }
    var pid = pageId(), tab = el.closest(".tab[data-opt][data-val]");
    if (tab && pid && LIVE[pid]) {
      var m = variants(pid).filter(function (v) { return tidy(v.options[tab.dataset.opt]) === tab.dataset.val; });
      if (m.length) return { r: range(m), how: pid + " option " + tab.dataset.val };
    }
    for (var n = el, d = 0; n && n !== D.body && d < 7; n = n.parentElement, d++) {
      var sets = n.matches("[data-set]") ? [n] : [].slice.call(n.querySelectorAll("[data-set]"));
      if (sets.length === 1) { var s = setSum(sets[0].getAttribute("data-set").split(/\s+/)); if (s) return { r: s, how: "set " + sets[0].getAttribute("data-set"), exact: true }; }
      if (sets.length > 1) return null;
      var ids = {};
      if (n.hasAttribute("data-add")) ids[n.getAttribute("data-add")] = 1;
      [].forEach.call(n.querySelectorAll("[data-add]"), function (b) { ids[b.getAttribute("data-add")] = 1; });
      var links = n.matches("a[href]") ? [n] : [];
      links = links.concat([].slice.call(n.querySelectorAll("a[href]")));
      links.forEach(function (a) { var k = idFromHref(a.getAttribute("href")); if (k) ids[k] = 1; });
      var ks = Object.keys(ids).filter(function (k) { return LIVE[k]; });
      if (ks.length === 1) return { r: range(variants(ks[0])), how: "product " + ks[0] };
      if (ks.length > 1) return null;
    }
    if (pid && LIVE[pid] && el.closest("#buy, .stickybar, .buycol")) return { r: range(variants(pid)), how: "page " + pid };
    return null;
  }
  var SEEN = {};
  function note(entry) { var k = entry.text + "|" + entry.how; if (!SEEN[k]) { SEEN[k] = 1; LOG.push(entry); } }
  var NAMES = null;
  function names() {
    if (NAMES) return NAMES;
    NAMES = [];
    Object.keys(LIVE).forEach(function (id) {
      var p = C.product && C.product(id), n = (p && p.name) || id.replace(/-/g, " ");
      var base = n.toLowerCase().replace(/&/g, "and");
      [base, base.replace(/s$/, ""), base + "s"].forEach(function (f) { NAMES.push({ f: f, id: id }); });
    });
    return NAMES;
  }
  function prose(t, el) {
    var out = "", last = 0, re = /(from\s+)?KSh\s?[\d,]+/gi, m, changed = false;
    var pid = pageId(), coffeeR = range([].concat.apply([], COFFEES.map(variants)));
    var allR = range([].concat.apply([], Object.keys(LIVE).map(variants)));
    while ((m = re.exec(t))) {
      var dot = t.lastIndexOf(". ", m.index), start = Math.max(dot >= 0 ? dot + 2 : 0, last), clause = t.slice(start, m.index).toLowerCase();
      var best = null, bestAt = -1;
      names().forEach(function (n) { var k = clause.lastIndexOf(n.f); if (k >= 0 && k + n.f.length > bestAt) { bestAt = k + n.f.length; best = { r: range(variants(n.id)), how: "name " + n.id }; } });
      if (!best && /coffee/.test(clause) && /pantry|brew|accessor|gear/.test(clause)) best = { r: allR, how: "everything" };
      if (!best && /coffee/.test(clause)) best = { r: coffeeR, how: "the coffees" };
      if (!best && pid && LIVE[pid]) {
        variants(pid).forEach(function (v) {
          (v.options || []).concat([v.title]).forEach(function (o) {
            /* only "200g, KSh 2,950"-style: the option must be what the price is attached to */
            var f = tidy(o).toLowerCase(), tail = clause.replace(/[\s,:\u00b7-]+$/, ""), k = tail.length - f.length;
            if (f && k >= 0 && tail.slice(k) === f && k + f.length > bestAt) { bestAt = k + f.length; best = { r: { lo: parseFloat(v.price), hi: parseFloat(v.price) }, how: "option " + o }; }
          });
        });
      }
      if (!best && /coffee/i.test(t) && /pantry|brew|accessor|gear/i.test(t)) best = { r: allR, how: "everything (sentence)" };
      if (!best && /coffee/i.test(t)) best = { r: coffeeR, how: "the coffees (sentence)" };
      if (!best || !best.r) { note({ text: t.trim().slice(0, 120), how: "UNMATCHED" }); continue; }
      var rep = priceText(best.r, m[0], false);
      if (!m[1] && best.r.hi > best.r.lo) rep = (t.slice(0, m.index).trim() === "" || /\.\s*$/.test(t.slice(0, m.index)) ? "From " : "from ") + fmt(best.r.lo);
      out += t.slice(last, m.index) + rep; last = m.index + m[0].length;
      if (rep !== m[0]) { changed = true; LOG.push({ text: m[0], to: rep, how: best.how, where: clause.slice(-50) }); }
    }
    return changed ? out + t.slice(last) : null;
  }
  function decide(t, el) {
    var s = t.trim();
    if (SHIPPING.test(s)) return null;
    var lab = s.match(LABEL), lead = s.match(LEAD), only = ONLY.test(s);
    if (only || lab || lead) {
      var block = el.closest("tr,li,dd,dt,p");
      if (only && block && SHIPPING.test(block.textContent)) return null;   /* a delivery fee, not a product */
      var c = context(el);
      if (!c || !c.r) { note({ text: s.slice(0, 80), how: "UNMATCHED (no product here)" }); return null; }
      var pm = s.match(/(from\s+)?KSh\s?[\d,]+/i), rep = priceText(c.r, pm[0], c.exact);
      if (lab && !pm[1]) rep = fmt(c.r.lo);
      if (rep === pm[0]) return null;
      LOG.push({ text: pm[0], to: rep, how: c.how });
      return t.replace(pm[0], rep);
    }
    return prose(t, el);
  }
  function paint(root) {
    if (!LIVE || BUSY) return;
    BUSY = true;
    try {
      var w = D.createTreeWalker(root || D.body, NodeFilter.SHOW_TEXT, null), list = [];
      while (w.nextNode()) if (w.currentNode.nodeValue.indexOf("KSh") >= 0) list.push(w.currentNode);
      list.forEach(function (n) {
        var el = n.parentElement;
        if (!el || el.closest(SKIP)) return;
        var out = decide(n.nodeValue, el);
        if (out !== null && out !== n.nodeValue) n.nodeValue = out;
      });
    } finally { BUSY = false; }
  }

  /* ---- checkout: make the store cart match the bag, then go ----------------------------- */
  D.addEventListener("click", function (e) {
    var a = e.target.closest && e.target.closest("a[data-checkout]");
    if (!a || !C.syncForCheckout || e.defaultPrevented) return;
    e.preventDefault();
    a.setAttribute("aria-busy", "true");
    C.syncForCheckout().then(function (u) { global.location.href = u || a.href; }, function () { global.location.href = a.href; });
  }, true);

  /* ---- start ----------------------------------------------------------------------- */
  function start() {
    API.ready = C.loadVariants().then(function (V) {
      if (!V) return;
      LIVE = V;
      return C.load().catch(function () {}).then(function () {
        var id = pageId();
        if (id && COFFEES.indexOf(id) >= 0) buildCoffee(id);
        paint();
        var t = null;
        new MutationObserver(function (ms) {
          if (BUSY) return;
          if (!ms.some(function (m) { return m.addedNodes.length; })) return;
          clearTimeout(t); t = setTimeout(function () { paint(); }, 120);
        }).observe(D.body, { childList: true, subtree: true });
      });
    });
  }
  if (D.readyState === "loading") D.addEventListener("DOMContentLoaded", start, { once: true }); else start();
})(window);
/* <<< AMKA-BLOCK blocks/live.js */

/* >>> AMKA-BLOCK blocks/cards.js */
/* AMKA GALLERY MOTION (motion round, 2026-09-24). Appended to /cdn/shop/t/5/assets/cart-ui--684a57e9.js after the live
   layer. The card design is unchanged. The product gallery's dots, arrows and arrow keys go to
   each image's real position (the old code ignored the 24 px gap, so a tap landed short and the
   snap corrected it), and its photos decode before a swipe reaches them. */
(function (global) {
  "use strict";
  var D = global.document;
  if (global.AmkaGalleryMotion) return;
  global.AmkaGalleryMotion = true;
  var REDUCE = global.matchMedia("(prefers-reduced-motion: reduce)");
  /* ---- the product gallery ----------------------------------------------------------- */
  function pos(track, i) { var k = track.children; return k[i].offsetLeft - k[0].offsetLeft; }
  function current(track) {
    var best = 0, d = Infinity;
    for (var i = 0; i < track.children.length; i++) {
      var dd = Math.abs(pos(track, i) - track.scrollLeft);
      if (dd < d) { d = dd; best = i; }
    }
    return best;
  }
  function goTo(track, i, from) {
    var n = track.children.length; i = Math.max(0, Math.min(n - 1, i));
    var y = global.scrollY;
    track.scrollTo({ left: pos(track, i), behavior: REDUCE.matches ? "auto" : "smooth" });
    if (from && from.focus) from.focus({ preventScroll: true });
    if (global.scrollY !== y) global.scrollTo(0, y);
  }
  D.addEventListener("click", function (e) {
    var b = e.target.closest && e.target.closest("#dots .dotb, #thumbs .thumb, .galarrow");
    var track = b && D.getElementById("galtrack");
    if (!track || !track.children.length) return;
    e.preventDefault(); e.stopImmediatePropagation();
    var i = b.hasAttribute("data-go") ? parseInt(b.getAttribute("data-go"), 10) : current(track) + parseInt(b.getAttribute("data-step") || "0", 10);
    goTo(track, i, b);
  }, true);
  D.addEventListener("keydown", function (e) {
    var track = e.target && e.target.id === "galtrack" ? e.target : null;
    if (!track) return;
    var n = track.children.length, i = current(track), to = null;
    if (e.key === "ArrowRight") to = i + 1; else if (e.key === "ArrowLeft") to = i - 1;
    else if (e.key === "Home") to = 0; else if (e.key === "End") to = n - 1;
    if (to === null) return;
    e.preventDefault(); e.stopImmediatePropagation(); goTo(track, to);
  }, true);

  /* the gallery's photos decode before a swipe reaches them: measured 2026-09-24, a drag spent
     about 90 ms decoding lazy images on the main thread, which is where its dropped frames came from */
  function warmGallery() {
    var track = D.getElementById("galtrack"); if (!track) return;
    [].forEach.call(track.querySelectorAll("img"), function (img) {
      img.decoding = "async";
      if (img.loading === "lazy") img.loading = "eager";
      if (img.decode) img.decode().catch(function () {});
    });
  }
  function whenIdle(fn) { (global.requestIdleCallback || function (f) { setTimeout(f, 600); })(fn, { timeout: 2500 }); }
  if (D.readyState === "complete") whenIdle(warmGallery); else global.addEventListener("load", function () { whenIdle(warmGallery); }, { once: true });


  /* the product-page announcement scrolls like the home ticker on phones (scan 2026-09-24) */
  function ticker() {
    var an = D.querySelector(".announce"); if (!an || an.querySelector(".amka-tick-track")) return;
    var sp = an.querySelector("span"); if (!sp) return;
    if (!global.matchMedia("(max-width:699px)").matches || REDUCE.matches) return;
    var parts = sp.textContent.split(/\s*\u00b7\s*/).filter(Boolean); if (parts.length < 2) return;
    var track = D.createElement("div"); track.className = "amka-tick-track"; track.setAttribute("aria-hidden", "true");
    for (var r = 0; r < 4; r++) parts.forEach(function (t) { var s = D.createElement("span"); s.textContent = t; track.appendChild(s); });
    sp.classList.add("amka-sr"); an.classList.add("amka-tick"); an.appendChild(track);
  }
  if (D.readyState === "loading") D.addEventListener("DOMContentLoaded", ticker, { once: true }); else ticker();
})(window);
/* <<< AMKA-BLOCK blocks/cards.js */
